import { create } from 'zustand'

export type RowMenu = 'date' | 'assign' | 'move' | 'more'

/**
 * Which task row the pointer is over, and which of its hover menus is open
 * (design 23). Row keys (X, D, A, M, ⌘⌫) act on the hovered row, or the
 * focused one, so the keyboard mirrors what hover shows.
 */
type TaskRowActionsState = {
  hoveredId: string | null
  openMenu: { taskId: string; menu: RowMenu } | null
  setHovered: (id: string | null) => void
  clearHovered: (id: string) => void
  setOpenMenu: (value: { taskId: string; menu: RowMenu } | null) => void
}

export const useTaskRowActionsStore = create<TaskRowActionsState>()((set) => ({
  hoveredId: null,
  openMenu: null,
  setHovered: (id) => set({ hoveredId: id }),
  clearHovered: (id) => set((state) => (state.hoveredId === id ? { hoveredId: null } : state)),
  setOpenMenu: (value) => set({ openMenu: value }),
}))
